import type { BaseResponse } from "~/@types";
import { http } from "~/libs/axios";

export type DashboardChecklistAction = "upload_proof" | "connect_account" | "info";

export interface DashboardChecklistItem {
  key: string; // nib | cashbook_30d | store_link | store_screenshot
  category: string; // Legalitas | Finansial | Pemasaran | Operasional
  title: string;
  description: string;
  action: DashboardChecklistAction;
  done: boolean;
}

export interface DashboardSummary {
  current_level: number;
  level_name: string;
  checklist_progress: number; // 0..100, sudah dihitung backend
  next_level: number | null;
  next_level_name: string | null;
  is_max_level: boolean;
  can_submit_upgrade: boolean;
  checklist: DashboardChecklistItem[];
}

type DashboardResponse = BaseResponse & { data: DashboardSummary };

export const dashboard = {
  // Ringkasan level + checklist "naik kelas" milik user yang sedang login.
  getDashboard: () => http<DashboardResponse>("GET", { url: "/dashboard" }),
};
